// extracted by mini-css-extract-plugin
module.exports = {"mobile":"500px","benefits":"Benefits_benefits__LFfk_","benefit":"Benefits_benefit__OjgYH","benefitText":"Benefits_benefitText__Ig1J5"};